<template>
  <v-container background fluid pa-4>
    <v-layout row wrap pa-0 style="background-color: #fff; border-radius: 5px">
      <v-flex xs12 pa-3>
        <v-layout row wrap>
          <v-flex xs12 text-xs-right>
            <v-btn
              style="
                margin-right: 10px;
                background-color: transparent;
                box-shadow: none;
              "
              @click="info_dialog = true"
            >
              <v-icon style="font-size: 16px; padding: 10px 0px" color="grey"
                >fa-info-circle</v-icon
              >
              <span>&nbsp;{{ $t("recommend") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-form ref="form" v-model="form_valid">
          <v-layout row wrap>
            <v-flex xs12 id="img_container">
              <img src="../../assets/employee.png" />
            </v-flex>
            <v-flex md6 sm6 xs12 offset-md4 offset-sm2>
              <v-radio-group
                v-model="form_model.emp_type"
                :column="false"
                hide-details
                :readonly="details.length != 0"
              >
                <v-radio :label="$t('monthly')" value="0" />
                <v-radio :label="$t('Daily')" value="1" />
                <v-radio :label="$t('Hourly')" value="2" />
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex
              md2
              sm4
              xs12
              offset-md4
              offset-sm2
              style="margin-right: 15px"
            >
              <v-btn
                color="warning"
                block
                class="white--text"
                @click="inputdownloadfile()"
              >
                <p
                  style="font-size: 12px; position: absolute; margin-top: 15px"
                >
                  {{ $t("DownloadExample") }}
                </p>
              </v-btn>
            </v-flex>
            <v-flex md2 sm4 xs12 class="button-wrapper">
              <span class="label">{{ $t("Upload") }}</span>
              <input
                :label="$t('ImportIncome')"
                type="file"
                id="file"
                ref="myFiles"
                class="upload-box"
                multiple
                @change="ImportExcel()"
                placeholder="Upload File"
              />
            </v-flex>
          </v-layout>
        </v-form>
        <v-flex md12 sm12 xs12>
          <v-layout row wrap v-if="details.length != 0">
            <v-flex
              md12
              sm12
              xs12
              v-for="(item, index) in details"
              :key="index"
              @click="&quot;&quot;;"
            >
              <v-card class="coco-box-shadow">
                <v-layout
                  align-center
                  justify-center
                  row
                  fill-height
                  wrap
                  class="coco-list-layout"
                >
                  <v-flex
                    lg1
                    md1
                    sm1
                    xs6
                    style="display: table-cell; vertical-align: middle"
                  >
                    <v-checkbox
                      v-model="item.check"
                      style="margin-top: 20px"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex lg1 md1 sm2 xs6>
                    <v-avatar :size="64">
                      <v-avatar
                        v-if="
                          item.emp_images == '' ||
                          item.emp_images == undefined ||
                          item.emp_images == null
                        "
                        :size="64"
                        color="teal"
                      >
                        <span class="white--text headline">{{
                          item.nick_name
                        }}</span>
                      </v-avatar>

                      <Empimage
                        v-if="
                          item.emp_images != '' &&
                          item.emp_images != undefined &&
                          item.emp_images != null
                        "
                        :json_data="item.emp_images"
                      />
                    </v-avatar>
                  </v-flex>
                  <v-flex lg7 md8 sm7 xs12>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-layout row wrap pa-1>
                          <v-flex lg3 md6 sm12 xs12>
                            <span class="coco-list-label-text"
                              >{{ item.code }}:</span
                            >
                            <span
                              >{{ item.name_title }} {{ item.first_name }} {{ item.last_name }}</span
                            >
                            <span
                              v-html="
                                ' (<span style=color:#166BFF;>' +
                                (isEmpty(item.nick_name)
                                  ? item.nick_name
                                  : 'nick_name') +
                                '</span>)'
                              "
                            />
                          </v-flex>
                          <v-flex lg6 md6 sm12 xs12>
                            <span class="coco-list-label-text">
                              {{ $t("IDcard") }} :
                              <span>
                                {{
                                  isEmpty(item.citizen_id)
                                    ? item.citizen_id
                                    : "citizen_id"
                                }}
                              </span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12>
                        <v-layout row wrap pa-1>
                          <v-flex lg3 md6 sm6 xs6>
                            <span class="coco-list-label-text">
                              {{ $t("branch") }} :
                              <span>
                                {{
                                  isEmpty(item.branch) ? item.branch : "branch"
                                }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md6 sm6 xs6>
                            <span class="coco-list-label-text">
                              {{ $t("Department") }} :
                              <span>
                                {{
                                  isEmpty(item.department)
                                    ? item.department
                                    : "department_name"
                                }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md6 sm6 xs6>
                            <span class="coco-list-label-text">
                              {{ $t("Position") }} :
                              <span>
                                {{
                                  isEmpty(item.position)
                                    ? item.position
                                    : "position"
                                }}
                              </span>
                            </span>
                          </v-flex>
                          <v-flex lg3 md6 sm6 xs6>
                            <span
                              class="coco-list-label-text"
                              v-if="form_model.emp_type == '0'"
                            >
                              {{ $t("Salary") }} :
                              <span>{{ item.salary }}</span>
                            </span>
                            <span
                              class="coco-list-label-text"
                              v-if="form_model.emp_type == '1'"
                            >
                              {{ $t("dailyearnings") }} :
                              <span>{{ item.daily_earnings }}</span>
                            </span>
                            <span
                              class="coco-list-label-text"
                              v-if="form_model.emp_type == '2'"
                            >
                              {{ $t("hourlyearnings") }} :
                              <span>{{ item.hourly_earnings }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap pa-1>
                          <v-flex lg3 md6 sm6 xs12>
                            <span class="coco-list-label-text">
                              {{ $t("startworkdate") }} :
                              <span>{{
                                formatdate(item.start_work_date)
                              }}</span>
                            </span>
                          </v-flex>
                          <v-flex
                            lg3
                            md6
                            sm6
                            xs12
                            v-if="item.promptpay_number == ''"
                          >
                            <span class="coco-list-label-text">
                              {{ $t("Bank") }} :
                              <span>{{ item.book_bank }}</span>
                            </span>
                          </v-flex>
                          <v-flex
                            lg3
                            md6
                            sm12
                            xs12
                            v-if="item.promptpay_number == ''"
                          >
                            <span class="coco-list-label-text">
                              {{ $t("Bankaccount") }} :
                              <span>{{ item.bank_code }}</span>
                            </span>
                          </v-flex>
                          <v-flex
                            lg3
                            md6
                            sm12
                            xs12
                            v-if="item.promptpay_number == ''"
                          >
                            <span class="coco-list-label-text">
                              {{ $t("AccountName") }} :
                              <span>{{ item.bank_name }}</span>
                            </span>
                          </v-flex>
                          <v-flex
                            lg3
                            md6
                            sm12
                            xs12
                            v-if="item.promptpay_number != ''"
                          >
                            <span class="coco-list-label-text">
                              {{ $t("Prompay") }} :
                              <span>{{ item.promptpay_number }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs12>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-right>
                        <v-layout row wrap text-xs-right>
                          <v-flex offset-lg5 offset-md3 offset-xs4 lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="EditItem(item, index)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{ $t("edit") }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs2>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="deleteItem(item, index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex
                    xs12
                    class="coco-list-divider"
                    style="
                      padding-left: 25px;
                      padding-right: 25px;
                      margin-top: 15px;
                      margin-bottom: 15px;
                    "
                  >
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn color="#D84315" @click="back()">
                <v-icon class="mr-2" style="color: #ffffff"
                  >fas fa-arrow-left</v-icon
                >
                <span style="color: #ffffff">{{ $t("back") }}</span>
              </v-btn>
              <v-btn
                color="#43A047"
                @click="save_dialog = true"
                v-if="permission_edit == true || admin == 'true'"
              >
                <v-icon class="mr-2" style="color: #ffffff">save</v-icon>
                <span style="color: #ffffff">{{ $t("save") }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>
      <!-- input dialog -->
      <v-flex>
        <v-dialog
          v-model="input_dialog"
          persistent
          scrollable
          max-width="600px"
        >
          <v-card>
            <v-card-title
              class="headline blue darken-1"
              primary-title
              style="color: white"
              >{{ $t("DownloadOptions") }}</v-card-title
            >
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6 pa-2>
                  <v-btn block color="info" @click="doToggleHeader('1')">{{
                    $t("DisplayAll")
                  }}</v-btn>
                </v-flex>
                <v-flex xs6 pa-2>
                  <v-btn
                    block
                    dark
                    color="deep-orange"
                    @click="doToggleHeader('0')"
                    >{{ $t("NoneDisplayAll") }}</v-btn
                  >
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md12 sm12 xs12 pa-2>
                  <h4 class="text-topic">{{ $t("EmployeeDetails") }}</h4>
                </v-flex>
              </v-layout>
              <v-divider
                style="margin-left: 8px; margin-right: 8px"
              ></v-divider>
              <v-layout row wrap pa-2>
                
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                  disabled
                    :label="$t('name_title')"
                    v-model="head_filedownload.name_title"
                    value="1"
                    hide-details
                    :readonly="true"
                  />
                </v-flex> 
             <v-flex md6 sm4 xs6>
                  <v-checkbox
                    disabled
                    :readonly="true"
                    :label="$t('employee_code')"
                    v-model="head_filedownload.code"
                    value="1"
                    hide-details
                  />
                </v-flex>
                
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('name')"
                    v-model="head_filedownload.first_name"
                    value="1"
                    hide-details
                    :readonly="true"
                    disabled
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :readonly="true"
                    :label="$t('lastname')"
                    v-model="head_filedownload.last_name"
                    value="1"
                    hide-details
                    disabled
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('nickname')"
                    v-model="head_filedownload.nick_name"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('IDcard')"
                    v-model="head_filedownload.citizen_id"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('birthday')"
                    v-model="head_filedownload.birth_date"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('gender')"
                    v-model="head_filedownload.gender"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('TelephoneNumber')"
                    v-model="head_filedownload.phone_num"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('nationality')"
                    v-model="head_filedownload.nationality"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('race')"
                    v-model="head_filedownload.race"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    label="LINE ID"
                    v-model="head_filedownload.line_id"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('email')"
                    v-model="head_filedownload.email"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Address')"
                    v-model="head_filedownload.address"
                    value="1"
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md12 sm12 xs12 pa-2>
                  <h4 class="text-topic">{{ $t("Workinformation") }}</h4>
                </v-flex>
              </v-layout>
              <v-divider
                style="margin-left: 8px; margin-right: 8px"
              ></v-divider>
              <v-layout row wrap pa-2>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('status')"
                    v-model="head_filedownload.status"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('NotusingTimeAttendancesystem')"
                    v-model="head_filedownload.not_cal_time"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Donotcalculateworkdays')"
                    v-model="head_filedownload.is_special"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    disabled
                    :readonly="true"
                    :label="$t('branch')"
                    v-model="head_filedownload.branch"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Department')"
                    v-model="head_filedownload.department"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Position')"
                    v-model="head_filedownload.position"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    disabled
                    :readonly="true"
                    :label="$t('startworkdate')"
                    v-model="head_filedownload.start_work_date"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6 v-if="form_model.emp_type == '0'">
                  <v-checkbox
                    :label="$t('Salary')"
                    v-model="head_filedownload.salary"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6 v-if="form_model.emp_type == '1'">
                  <v-checkbox
                    :label="$t('dailyearnings')"
                    v-model="head_filedownload.daily_earnings"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6 v-if="form_model.emp_type == '2'">
                  <v-checkbox
                    :label="$t('hourlyearnings')"
                    v-model="head_filedownload.hourly_earnings"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Notusesocialsecuritypaymentsystem')"
                    v-model="head_filedownload.is_auto_ss"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Notusetaxcalculationsystem')"
                    v-model="head_filedownload.is_auto_tax"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('SocialSecurity')"
                    v-model="head_filedownload.deduct_ss"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('deducttax')"
                    v-model="head_filedownload.deduct_tax"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('craftAmount')"
                    v-model="head_filedownload.income_craft"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('PositionAmount')"
                    v-model="head_filedownload.income_position"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('extraAmount')"
                    v-model="head_filedownload.income_special"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('PaymentType')"
                    v-model="head_filedownload.payment_type"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Bank')"
                    v-model="head_filedownload.book_bank"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Bankaccount')"
                    v-model="head_filedownload.bank_code"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('AccountName')"
                    v-model="head_filedownload.bank_name"
                    value="1"
                    hide-details
                  />
                </v-flex>
                <v-flex md6 sm4 xs6>
                  <v-checkbox
                    :label="$t('Prompay')"
                    v-model="head_filedownload.promptpay_number"
                    value="1"
                    hide-details
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="input_dialog = false">{{
                $t("cancel")
              }}</v-btn>
              <v-btn color="primary" text @click="DownloadExampleExcel()">{{
                $t("submit")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- reactive dialog -->
      <v-flex>
        <v-dialog v-model="save_dialog" max-width="300">
          <v-card>
            <v-card-title
              class="headline green darken-1"
              primary-title
              style="color: white"
              >{{ $t("save") }}</v-card-title
            >
            <v-card-text>
              <v-layout row wrap pa-2>
                <v-flex xs12 style="margin-top: 5px">{{
                  $t("question.save")
                }}</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="save_dialog = false">{{
                $t("cancel")
              }}</v-btn>
              <v-btn color="primary" text @click="onSave()">{{
                $t("submit")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- recommend dialog -->
      <v-dialog v-model="info_dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $t("recommend") }}
          </v-card-title>

          <v-card-text>
            <v-flex md12 sm12 xs12 pa-2>
              <br />
              <h4 class="text-xl-left">
                การกรอกข้อมูลในไฟล์ excle ที่ ดาวน์โหลดตัวอย่าง
              </h4>
              <br />
            </v-flex>
            <v-layout row warp>
              <v-flex md6 sm6 xs12>
                <p class="text-xl-left">
                  <strong>เพศ</strong> <br />
                  - เพศชาย = male <br />
                  - เพศหญิง = female
                </p>
                <p class="text-xl-left">
                  <strong>สถานะ</strong> <br />
                  - ฝึกงาน = 0 <br />
                  - บรรจุ = 1 <br />
                  - ฝึกงาน = 2
                </p>
                <p class="text-xl-left">
                  <strong>ไม่ใช้ระบบเวลาเข้างาน</strong> <br />
                  - ใช้ระบบ = 0 <br />
                  - ไม่ใช้ระบบ = 1
                </p>
                <p class="text-xl-left">
                  <strong>ไม่คำนวณวันทำงาน</strong> <br />
                  - คำนวณ = 0 <br />
                  - ไม่คำนวณ = 1
                </p>
              </v-flex>
              <v-flex md6 sm6 xs12>
                <p class="text-xl-left">
                  <strong>ไม่ใช้ระบบคำนวณเงินประกันสังคม</strong> <br />
                  - ใช้ระบบ = 0 <br />
                  - ไม่ใช้ระบบ = 1
                </p>
                <p class="text-xl-left">
                  <strong>ไม่ใช้ระบบคำนวณภาษี</strong> <br />
                  - ใช้ระบบ = 0 <br />
                  - ไม่ใช้ระบบ = 1
                </p>
                <p class="text-xl-left">
                  <strong>ประเภทการจ่ายเงิน</strong> <br />
                  - เงินโอน = 0 <br />
                  - พร้อมเพย์ = 1 <br />
                  - เงินสด = 2 <br />
                  - อื่นๆ = 3
                </p>
              </v-flex>
            </v-layout>
            <v-flex md12 sm12 xs12 pa-2>
              <p class="text-xl-left">
                <strong>
                  <font color="red">#</font> ในกรณีช่องข้อมูลเป็นว่าง
                  หรือไม่มีข้อมูล ไม่ต้องใส่ "-" ในช่องข้อมูลนั้น
                  <font color="red">#</font></strong
                >
              </p>
            </v-flex>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="info_dialog = false">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" scrollable max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t("menu.EmployeeEdit") }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-tabs v-model="tab" background-color="primary">
              <v-tab>{{ $t("EmployeeDetails") }}</v-tab>
              <v-tab>{{ $t("Workinformation") }}</v-tab>
            </v-tabs>
            <v-card-text style="height: 400px">
              <v-container grid-list-md>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('code')"
                          type="text"
                          v-model="form_dialog.code"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('IDcard')"
                          type="number"
                          v-model="form_dialog.citizen_id"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('name_title')"
                          type="text"
                          v-model="form_dialog.name_title"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('name')"
                          type="text"
                          v-model="form_dialog.first_name"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('lastname')"
                          type="text"
                          v-model="form_dialog.last_name"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('nickname')"
                          type="text"
                          v-model="form_dialog.nick_name"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('birthday')"
                          type="date"
                          v-model="form_dialog.birth_date"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 sm6 xs12>
                        <h3>{{ $t("gender") }}</h3>
                        <v-radio-group
                          v-model="form_dialog.gender"
                          :column="false"
                        >
                          <v-radio :label="$t('male')" value="male" />
                          <v-radio :label="$t('female')" value="female" />
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('TelephoneNumber')"
                          type="phone"
                          v-model="form_dialog.phone_num"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('nationality')"
                          v-model="form_dialog.nationality"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('race')"
                          v-model="form_dialog.race"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          label="LINE ID"
                          v-model="form_dialog.line_id"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('email')"
                          v-model="form_dialog.email"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('branch')"
                          type="text"
                          v-model="form_dialog.branch"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('Address')"
                          v-model="form_dialog.address"
                        />
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                  <v-tab-item>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12 pa-1>
                        <h4>{{ $t("status") }}</h4>
                        <v-layout row wrap>
                          <v-flex md12 sm12 xs12>
                            <v-radio-group
                              v-model="form_dialog.status"
                              :column="false"
                            >
                              <v-radio :label="$t('apprentice')" value="0" />
                              <v-radio :label="$t('placement')" value="1" />
                              <v-radio :label="$t('suspended')" value="2" />
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-checkbox
                          :label="$t('NotusingTimeAttendancesystem')"
                          value="1"
                          v-model="form_dialog.not_cal_time"
                        />
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-checkbox
                          :label="$t('Donotcalculateworkdays')"
                          value="1"
                          v-model="form_model.is_special"
                        />
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('branch')"
                          type="text"
                          v-model="form_dialog.branch"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('Department')"
                          type="text"
                          v-model="form_dialog.department"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('Position')"
                          type="text"
                          v-model="form_dialog.position"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-text-field
                          :label="$t('startworkdate')"
                          type="date"
                          v-model="form_dialog.start_work_date"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 v-if="form_model.emp_type == '0'">
                        <v-text-field
                          :label="$t('Salary')"
                          type="text"
                          v-model="form_dialog.salary"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 v-if="form_model.emp_type == '1'">
                        <v-text-field
                          :label="$t('dailyearnings')"
                          type="text"
                          v-model="form_dialog.daily_earnings"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 v-if="form_model.emp_type == '2'">
                        <v-text-field
                          :label="$t('hourlyearnings')"
                          type="text"
                          v-model="form_dialog.hourly_earnings"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 sm12 xs12>
                        <h4>{{ $t("listDeductions") }}</h4>
                        <v-layout row wrap>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-checkbox
                              :label="$t('Notusesocialsecuritypaymentsystem')"
                              value="1"
                              v-model="form_dialog.is_auto_ss"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-checkbox
                              :label="$t('Notusetaxcalculationsystem')"
                              value="1"
                              v-model="form_dialog.is_auto_tax"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('SocialSecurity')"
                              v-model="form_dialog.deduct_ss"
                              type="number"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('deducttax')"
                              v-model="form_dialog.deduct_tax"
                              type="number"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex md12 sm12 xs12>
                        <h4>{{ $t("Otherextraincome") }}</h4>
                        <v-layout row wrap>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('craftAmount')"
                              v-model="form_dialog.income_craft"
                              type="number"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('PositionAmount')"
                              v-model="form_dialog.income_position"
                              type="number"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('extraAmount')"
                              v-model="form_dialog.income_special"
                              type="number"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex md12 sm12 xs12 pa-1>
                        <h3>{{ $t("Bankaccountinformation") }}</h3>
                        <v-layout row wrap>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-select
                              required
                              :items="pay_items"
                              :label="$t('PaymentType')"
                              v-model="form_dialog.payment_type"
                              item-text="name"
                              item-value="code"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('Bank')"
                              v-model="form_dialog.book_bank"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('Bankaccount')"
                              v-model="form_dialog.bank_code"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('AccountName')"
                              v-model="form_dialog.bank_name"
                            />
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field
                              :label="$t('Prompay')"
                              v-model="form_dialog.promptpay_number"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                </v-tabs-items>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false"
                >Close</v-btn
              >
              <v-btn
                color="blue darken-1"
                flat
                @click="
                  dialog = false;
                  onUpdate();
                "
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Empimage from "../../components/getempimage.vue";
import UserService from "@/services/UserService";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
import { async } from "q";
export default {
  data: () => ({
    pay_items: [
      {
        code: "0",
        name: "เงินโอน",
      },
      {
        code: "1",
        name: "พร้อมเพย์",
      },
      {
        code: "2",
        name: "เงินสด",
      },
      {
        code: "3",
        name: "อื่นๆ",
      },
    ],
    tab: 0,
    detail: [],
    dialog_create: false,
    info_dialog: false,
    branch: "",
    department: "",
    emp_code: "",
    branch_items: [],
    department_items: [],
    Employee_items: [],
    selected: [],
    isChecked: false,
    form_valid: false,
    dialog: false,
    input_dialog: false,
    save_dialog: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object,
    },
    delete_dialog_data: {
      status: false,
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    index: 0,
    form_dialog: {
      name_title: "",
      code: "",
      citizen_id: "",
      first_name: "",
      last_name: "",
      nick_name: "",
      birth_date: "",
      gender: "",
      phone_num: "",
      nationality: "",
      race: "",
      line_id: "",
      email: "",
      address: "",
      status: "",
      not_cal_time: "",
      is_special: "",
      branch: "",
      department: "",
      position: "",
      start_work_date: "",
      salary: "",
      earning_daytype: "",
      earning_hourtype: "",
      is_auto_ss: "",
      is_auto_tax: "",
      deduct_ss: "",
      deduct_tax: "",
      income_craft: "",
      income_position: "",
      income_special: "",
      payment_type: "",
      book_bank: "",
      bank_code: "",
      bank_name: "",
      promptpay_number: "",
    },
    form_model: {
      company_guid: localStorage._company_guid,
      user_name: "",
      user_password: "",
      code: "",
      name_title: "นาย",
      nick_name: "",
      is_auto_ss: "0",
      is_auto_tax: "0",
      is_training: "0",
      is_special: "1",
      plan_type: "0",
      first_name: "",
      weekends: "",
      holiday_profile: "",
      deduct_ss: 0,
      deduct_tax: 0,
      calworkhour: 8,
      income_craft: 0,
      income_position: 0,
      income_special: 0,
      promptpay_number: "",
      not_cal_time: "0",
      payment_type: 0,
      last_name: "",
      nationality: "",
      emp_type: "0",
      earning_daytype: "0",
      daily_monday: 0,
      daily_tuesday: 0,
      daily_wednesday: 0,
      daily_thursday: 0,
      daily_friday: 0,
      daily_saturday: 0,
      daily_sunday: 0,
      daily_holiday: 0,
      earning_hourtype: "0",
      hour_monday: 0,
      hour_tuesday: 0,
      hour_wednesday: 0,
      hour_thursday: 0,
      hour_friday: 0,
      hour_saturday: 0,
      hour_sunday: 0,
      hour_holiday: 0,
      form_hour_1: 0,
      to_hour_1: 0,
      hourearning_1: 0,
      form_hour_2: 0,
      to_hour_2: 0,
      hourearning_2: 0,
      birth_date: "",
      address: "",
      gender: "male",
      phone_num: "",
      email: "",
      race: "",
      line_id: "",
      citizen_id: "",
      position: "",
      approver: localStorage._usercode,
      start_work_date: "",
      packing_date: "",
      status: "1",
      branch: "",
      faction: "",
      department: "",
      start_salary: 0,
      packing_salary: 0,
      daily_earnings: 0,
      hourly_earnings: 0,
      book_bank: "",
      bank_name: "",
      bank_code: "",
      shift_profile: "",
      conditions_profile: "",
      emp_images: [],
      taxsetting: {},
      creator_code: localStorage._usercode,
      tax_detail: [
        {
          name: "add_income",
          type: 1,
          percent: 0,
          max: 0,
          value: 0,
        },
        {
          name: "expensed",
          type: 0,
          percent: 50,
          max: 100000,
        },
      ],
    },
    form_dialog_create: {
      name_doc: "",
      date: "",
      remark: "",
    },
    head_filedownload: {
      name_title: "1",
      code: "1",
      citizen_id: "1",
      first_name: "1",
      last_name: "1",
      nick_name: "1",
      birth_date: "1",
      gender: "1",
      phone_num: "1",
      nationality: "1",
      race: "1",
      line_id: "1",
      email: "1",
      address: "1",
      status: "1",
      not_cal_time: "1",
      is_special: "1",
      branch: "1",
      department: "1",
      position: "1",
      start_work_date: "1",
      is_auto_ss: "1",
      is_auto_tax: "1",
      deduct_ss: "1",
      deduct_tax: "1",
      income_craft: "1",
      income_position: "1",
      income_special: "1",
      payment_type: "1",
      book_bank: "1",
      bank_code: "1",
      bank_name: "1",
      promptpay_number: "1",
    },
    detail_example: [],
    details: [],
    results: [],
    // IncomeData: [],
    name: [],

    checkdata: true,
    taxsetting: [],
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
    ListEmployee: [],
    json_create: [],
    json_update: [],
  }),

  components: {
    DeleteDialog,
    Empimage,
  },
  created: async function () {
    this.admin = localStorage._is_admin;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("ImportEmployee");
    console.log(this.check_permission);
    await this.getAllEmployee();
    await this.getProfileBranchList();
    await this.commitSetToolbar({ patternTool: "0" });
  },
  computed: {
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols",
    ]),
    ...mapState("filter", ["loading", "Employee_List"]),
    // ...mapState("permissionmenu", ["permission_List"]),

    // selectAllEmp() {
    //   return this.name.length === this.Employee_List.length;
    // },
    // selectSomeEmp() {
    //   console.log(this.name);
    //   return this.name.length > 0 && !this.selectAllEmp;
    // }
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    inputdownloadfile() {
      this.head_filedownload = {
        name_title: "1",
        code: "1",
        citizen_id: "1",
        first_name: "1",
        last_name: "1",
        nick_name: "1",
        birth_date: "1",
        gender: "1",
        phone_num: "1",
        nationality: "1",
        race: "1",
        line_id: "1",
        email: "1",
        address: "1",
        status: "1",
        not_cal_time: "1",
        is_special: "1",
        branch: "1",
        department: "1",
        position: "1",
        start_work_date: "1",
        is_auto_ss: "1",
        is_auto_tax: "1",
        deduct_ss: "1",
        deduct_tax: "1",
        income_craft: "1",
        income_position: "1",
        income_special: "1",
        payment_type: "1",
        book_bank: "1",
        bank_code: "1",
        bank_name: "1",
        promptpay_number: "1",
      };
      if (this.form_model.emp_type == "0") {
        this.head_filedownload.salary = "1";
      }
      if (this.form_model.emp_type == "1") {
        this.head_filedownload.daily_earnings = "1";
      }
      if (this.form_model.emp_type == "2") {
        this.head_filedownload.hourly_earnings = "1";
      }

      this.input_dialog = true;
    },
    doToggleHeader(status) {
      this.head_filedownload = {
        name_title: '1',
        code: '1',
        citizen_id: status,
        first_name: '1',
        last_name: '1',
        nick_name: status,
        birth_date: status,
        gender: status,
        phone_num: status,
        nationality: status,
        race: status,
        line_id: status,
        email: status,
        address: status,
        status: status,
        not_cal_time: status,
        is_special: status,
        branch: '1',
        department: status,
        position: status,
        start_work_date: '1',
        salary: status,
        is_auto_ss: status,
        is_auto_tax: status,
        deduct_ss: status,
        deduct_tax: status,
        income_craft: status,
        income_position: status,
        income_special: status,
        payment_type: status,
        book_bank: status,
        bank_code: status,
        bank_name: status,
        promptpay_number: status,
      };
      if (this.form_model.emp_type == "0") {
        this.head_filedownload.salary = status;
      }
      if (this.form_model.emp_type == "1") {
        this.head_filedownload.daily_earnings = status;
      }
      if (this.form_model.emp_type == "2") {
        this.head_filedownload.hourly_earnings = status;
      }
    },
    getAllEmployee() {
      EmployeeService.getAllEmployee()
        .then((res) => {
          this.ListEmployee = res.data;
          console.log(res);
        })
        .catch((err) => {});
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    doNewGuid() {
      this.emp_code = Utils.newGuid("EMP");
    },
    DownloadExampleExcel() {
      let v = this;
      var namefile = "";
      let detail = {};
      v.head_example = [];
      v.detail_example = [];
      if (v.head_filedownload.name_title == "1") {
        v.head_example.push("คำนำหน้าชื่อ");
        detail.คำนำหน้าชื่อ = "นาย";
      }
      if (v.head_filedownload.code == "1") {
        v.head_example.push("รหัสพนักงาน");
        detail.รหัสพนักงาน = "EMP-1234";
      }
      if (v.head_filedownload.citizen_id == "1") {
        v.head_example.push("บัตรประชาชน");
        detail.บัตรประชาชน = "123456789012";
      }
      if (v.head_filedownload.first_name == "1") {
        v.head_example.push("ชื่อ");
        detail.ชื่อ = "สมใจ";
      }
      if (v.head_filedownload.last_name == "1") {
        v.head_example.push("นามสกุล");
        detail.นามสกุล = "ใจดี";
      }
      if (v.head_filedownload.nick_name == "1") {
        v.head_example.push("ชื่อเล่น");
        detail.ชื่อเล่น = "ใจ";
      }
      if (v.head_filedownload.birth_date == "1") {
        v.head_example.push("วันเกิด");
        detail.วันเกิด = "2019-01-01";
      }
      if (v.head_filedownload.gender == "1") {
        v.head_example.push("เพศ");
        detail.เพศ = "female";
      }
      if (v.head_filedownload.phone_num == "1") {
        v.head_example.push("เบอร์โทรศัพท์");
        detail.เบอร์โทรศัพท์ = "0912345678";
      }
      if (v.head_filedownload.nationality == "1") {
        v.head_example.push("สัญชาติ");
        detail.สัญชาติ = "ไทย";
      }
      if (v.head_filedownload.race == "1") {
        v.head_example.push("เชื้อชาติ");
        detail.เชื้อชาติ = "ไทย";
      }
      if (v.head_filedownload.line_id == "1") {
        v.head_example.push("LineID");
        detail.LineID = "Somjai";
      }
      if (v.head_filedownload.email == "1") {
        v.head_example.push("อีเมลล์");
        detail.อีเมลล์ = "Somjai123@gmail.com";
      }
      if (v.head_filedownload.address == "1") {
        v.head_example.push("ที่อยู่");
        detail.ที่อยู่ = "123/1 กรุงเทพฯ";
      }
      if (v.head_filedownload.status == "1") {
        v.head_example.push("สถานะ");
        detail.สถานะ = "1";
      }
      if (v.head_filedownload.not_cal_time == "1") {
        v.head_example.push("ไม่ใช้ระบบเวลาเข้างาน");
        detail.ไม่ใช้ระบบเวลาเข้างาน = "1";
      }
      if (v.head_filedownload.is_special == "1") {
        v.head_example.push("ไม่คำนวณวันทำงาน");
        detail.ไม่คำนวณวันทำงาน = "1";
      }
      if (v.head_filedownload.branch == "1") {
        v.head_example.push("สาขา");
        detail.สาขา = "00000";
      }
      if (v.head_filedownload.department == "1") {
        v.head_example.push("แผนก");
        detail.แผนก = "D-1234";
      }
      if (v.head_filedownload.position == "1") {
        v.head_example.push("ตำแหน่ง");
        detail.ตำแหน่ง = "บัญชี";
      }
      if (v.head_filedownload.start_work_date == "1") {
        v.head_example.push("วันที่เริ่มงาน");
        detail.วันที่เริ่มงาน = "2019-01-01";
      }
      if (v.head_filedownload.salary == "1" && v.form_model.emp_type == "0") {
        v.head_example.push("เงินเดือน");
        detail.เงินเดือน = "15000";
        namefile = "Monthly";
      }
      if (
        v.head_filedownload.daily_earnings == "1" &&
        v.form_model.emp_type == "1"
      ) {
        v.head_example.push("เงินรายวัน");
        detail.เงินรายวัน = "300";
        namefile = "Daily";
      }
      if (
        v.head_filedownload.hourly_earnings == "1" &&
        v.form_model.emp_type == "2"
      ) {
        v.head_example.push("เงินรายชั่วโมง");
        detail.เงินรายชั่วโมง = "80";
        namefile = "Hourly";
      }
      if (v.head_filedownload.is_auto_ss == "1") {
        v.head_example.push("ไม่ใช้ระบบคำนวณเงินประกันสังคม");
        detail.ไม่ใช้ระบบคำนวณเงินประกันสังคม = "1";
      }
      if (v.head_filedownload.is_auto_tax == "1") {
        v.head_example.push("ไม่ใช้ระบบคำนวณภาษี");
        detail.ไม่ใช้ระบบคำนวณภาษี = "0";
      }
      if (v.head_filedownload.deduct_ss == "1") {
        v.head_example.push("ประกันสังคม");
        detail.ประกันสังคม = "750";
      }
      if (v.head_filedownload.deduct_tax == "1") {
        v.head_example.push("ภาษีหัก_ณ_ที่จ่าย");
        detail.ภาษีหัก_ณ_ที่จ่าย = "0";
      }
      if (v.head_filedownload.income_craft == "1") {
        v.head_example.push("ค่าฝืมือ");
        detail.ค่าฝืมือ = "0";
      }
      if (v.head_filedownload.income_position == "1") {
        v.head_example.push("ค่าตำแหน่ง");
        detail.ค่าตำแหน่ง = "0";
      }
      if (v.head_filedownload.income_special == "1") {
        v.head_example.push("ค่าพิเศษ");
        detail.ค่าพิเศษ = "0";
      }
      if (v.head_filedownload.payment_type == "1") {
        v.head_example.push("ประเภทการจ่ายเงิน");
        detail.ประเภทการจ่ายเงิน = "0";
      }
      if (v.head_filedownload.book_bank == "1") {
        v.head_example.push("ธนาคาร");
        detail.ธนาคาร = "SCB";
      }
      if (v.head_filedownload.bank_code == "1") {
        v.head_example.push("เลขที่บัญชีธนาคาร");
        detail.เลขที่บัญชีธนาคาร = "123456789";
      }
      if (v.head_filedownload.bank_name == "1") {
        v.head_example.push("ชื่อบัญชี");
        detail.ชื่อบัญชี = "สมใจ ใจดี";
      }
      if (v.head_filedownload.promptpay_number == "1") {
        v.head_example.push("พร้อมเพย์");
        detail.พร้อมเพย์ = "";
      }
      v.detail_example.push(detail);
      console.log(v.detail_example);
      v.input_dialog = false;
      console.log(v.detail_example);
      var config = { raw: true, type: "string" };
      var Example = XLSX.utils.json_to_sheet(
        v.detail_example,
        v.head_example,
        config
      );
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, Example, "ImportEmployee" + namefile);
      XLSX.writeFile(wb, "ImportEmployee" + namefile + ".xlsx");
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function (e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        v.details = [];
        for (let index = 0; index < v.results.length; index++) {
          let detail = [];
          console.log(v.results);
          console.log(v.form_model.emp_type);
          if (
            v.results[index].คำนำหน้าชื่อ != " " &&
            v.results[index].คำนำหน้าชื่อ != undefined
          ) {
            detail.name_title = v.results[index].คำนำหน้าชื่อ;
          }
          if (
            v.results[index].รหัสพนักงาน != " " &&
            v.results[index].รหัสพนักงาน != undefined
          ) {
            detail.code = v.results[index].รหัสพนักงาน;
          }
          if (
            v.results[index].บัตรประชาชน != " " &&
            v.results[index].บัตรประชาชน != undefined
          ) {
            detail.citizen_id = v.results[index].บัตรประชาชน;
          }
          if (
            v.results[index].ชื่อ != " " &&
            v.results[index].ชื่อ != undefined
          ) {
            detail.first_name = v.results[index].ชื่อ;
          }
          if (
            v.results[index].นามสกุล != " " &&
            v.results[index].นามสกุล != undefined
          ) {
            detail.last_name = v.results[index].นามสกุล;
          }
          if (
            v.results[index].ชื่อเล่น != " " &&
            v.results[index].ชื่อเล่น != undefined
          ) {
            detail.nick_name = v.results[index].ชื่อเล่น;
          }
          if (
            v.results[index].วันเกิด != " " &&
            v.results[index].วันเกิด != undefined
          ) {
            detail.birth_date = v.results[index].วันเกิด;
          }
          if (
            v.results[index].เพศ != " " &&
            v.results[index].เพศ != undefined
          ) {
            detail.gender = v.results[index].เพศ;
          }
          if (
            v.results[index].เบอร์โทรศัพท์ != " " &&
            v.results[index].เบอร์โทรศัพท์ != undefined
          ) {
            detail.phone_num = v.results[index].เบอร์โทรศัพท์;
          }
          if (
            v.results[index].สัญชาติ != " " &&
            v.results[index].สัญชาติ != undefined
          ) {
            detail.nationality = v.results[index].สัญชาติ;
          }
          if (
            v.results[index].เชื้อชาติ != " " &&
            v.results[index].เชื้อชาติ != undefined
          ) {
            detail.race = v.results[index].เชื้อชาติ;
          }
          if (
            v.results[index].LineID != " " &&
            v.results[index].LineID != undefined
          ) {
            detail.line_id = v.results[index].LineID;
          }
          if (
            v.results[index].อีเมลล์ != " " &&
            v.results[index].อีเมลล์ != undefined
          ) {
            detail.email = v.results[index].อีเมลล์;
          }
          if (
            v.results[index].ที่อยู่ != " " &&
            v.results[index].ที่อยู่ != undefined
          ) {
            detail.address = v.results[index].ที่อยู่;
          }
          if (
            v.results[index].สถานะ != " " &&
            v.results[index].สถานะ != undefined
          ) {
            detail.status = v.results[index].สถานะ;
          }
          if (
            v.results[index].ไม่ใช้ระบบเวลาเข้างาน != " " &&
            v.results[index].ไม่ใช้ระบบเวลาเข้างาน != undefined
          ) {
            detail.not_cal_time = v.results[index].ไม่ใช้ระบบเวลาเข้างาน;
          }
          if (
            v.results[index].ไม่คำนวณวันทำงาน != " " &&
            v.results[index].ไม่คำนวณวันทำงาน != undefined
          ) {
            detail.is_special = v.results[index].ไม่คำนวณวันทำงาน;
          }
          if (
            v.results[index].สาขา != " " &&
            v.results[index].สาขา != undefined
          ) {
            detail.branch = v.results[index].สาขา;
          }
          if (
            v.results[index].แผนก != " " &&
            v.results[index].แผนก != undefined
          ) {
            detail.department = v.results[index].แผนก;
          }
          if (
            v.results[index].ตำแหน่ง != " " &&
            v.results[index].ตำแหน่ง != undefined
          ) {
            detail.position = v.results[index].ตำแหน่ง;
          }
          if (
            v.results[index].วันที่เริ่มงาน != " " &&
            v.results[index].วันที่เริ่มงาน != undefined
          ) {
            detail.start_work_date = v.results[index].วันที่เริ่มงาน;
          }
          if (
            v.results[index].เงินเดือน != " " &&
            v.results[index].เงินเดือน != undefined &&
            v.form_model.emp_type == "0"
          ) {
            detail.salary = v.results[index].เงินเดือน;
          } else if (
            v.results[index].เงินรายวัน != " " &&
            v.results[index].เงินรายวัน != undefined &&
            v.form_model.emp_type == "1"
          ) {
            detail.daily_earnings = v.results[index].เงินรายวัน;
          } else if (
            v.results[index].เงินรายชั่วโมง != " " &&
            v.results[index].เงินรายชั่วโมง != undefined &&
            v.form_model.emp_type == "2"
          ) {
            detail.hourly_earnings = v.results[index].เงินรายชั่วโมง;
          }

          if (
            v.results[index].ไม่ใช้ระบบคำนวณเงินประกันสังคม != " " &&
            v.results[index].ไม่ใช้ระบบคำนวณเงินประกันสังคม != undefined
          ) {
            detail.is_auto_ss = v.results[index].ไม่ใช้ระบบคำนวณเงินประกันสังคม;
          }
          if (
            v.results[index].ไม่ใช้ระบบคำนวณภาษี != " " &&
            v.results[index].ไม่ใช้ระบบคำนวณภาษี != undefined
          ) {
            detail.is_auto_tax = v.results[index].ไม่ใช้ระบบคำนวณภาษี;
          }
          if (
            v.results[index].ประกันสังคม != " " &&
            v.results[index].ประกันสังคม != undefined
          ) {
            detail.deduct_ss = v.results[index].ประกันสังคม;
          }
          if (
            v.results[index].ภาษีหัก_ณ_ที่จ่าย != " " &&
            v.results[index].ภาษีหัก_ณ_ที่จ่าย != undefined
          ) {
            detail.deduct_tax = v.results[index].ภาษีหัก_ณ_ที่จ่าย;
          }
          if (
            v.results[index].ค่าฝืมือ != " " &&
            v.results[index].ค่าฝืมือ != undefined
          ) {
            detail.income_craft = v.results[index].ค่าฝืมือ;
          }
          if (
            v.results[index].ค่าตำแหน่ง != " " &&
            v.results[index].ค่าตำแหน่ง != undefined
          ) {
            detail.income_position = v.results[index].ค่าตำแหน่ง;
          }
          if (
            v.results[index].ค่าพิเศษ != " " &&
            v.results[index].ค่าพิเศษ != undefined
          ) {
            detail.income_special = v.results[index].ค่าพิเศษ;
          }
          if (
            v.results[index].ประเภทการจ่ายเงิน != " " &&
            v.results[index].ประเภทการจ่ายเงิน != undefined
          ) {
            detail.payment_type = v.results[index].ประเภทการจ่ายเงิน;
          }
          if (
            v.results[index].ธนาคาร != " " &&
            v.results[index].ธนาคาร != undefined
          ) {
            detail.book_bank = v.results[index].ธนาคาร;
          }
          if (
            v.results[index].เลขที่บัญชีธนาคาร != " " &&
            v.results[index].เลขที่บัญชีธนาคาร != undefined
          ) {
            detail.bank_code = v.results[index].เลขที่บัญชีธนาคาร;
          }
          if (
            v.results[index].ชื่อบัญชี != " " &&
            v.results[index].ชื่อบัญชี != undefined
          ) {
            detail.bank_name = v.results[index].ชื่อบัญชี;
          }
          if (
            v.results[index].พร้อมเพย์ != " " &&
            v.results[index].พร้อมเพย์ != undefined
          ) {
            detail.promptpay_number = v.results[index].พร้อมเพย์;
          }
          if (
            v.results[index].วันหยุดประจำปี != " " &&
            v.results[index].วันหยุดประจำปี != undefined
          ) {
            detail.holiday_profile = v.results[index].วันหยุดประจำปี;
          }
          console.log(v.details);
          switch (v.form_model.emp_type) {
            case "0":
              if (v.results[index].เงินเดือน != undefined) {
                v.details.push(detail);
              } else if (v.results[index].เงินเดือน == undefined) {
                v.snack_model.status = true;
                v.snack_model.msg =
                  "กรุณาเลือกประเภทพนักงานให้ตรงกับข้อมูลนำเข้า";
                v.snack_model.type = "error";
              }
              break;
            case "1":
              if (v.results[index].เงินรายวัน != undefined) {
                v.details.push(detail);
              } else if (v.results[index].เงินรายวัน == undefined) {
                v.snack_model.status = true;
                v.snack_model.msg =
                  "กรุณาเลือกประเภทพนักงานให้ตรงกับข้อมูลนำเข้า";
                v.snack_model.type = "error";
              }
              break;
            case "2":
              if (v.results[index].เงินรายชั่วโมง != undefined) {
                v.details.push(detail);
              } else if (v.results[index].เงินรายชั่วโมง == undefined) {
                v.snack_model.status = true;
                v.snack_model.msg =
                  "กรุณาเลือกประเภทพนักงานให้ตรงกับข้อมูลนำเข้า";
                v.snack_model.type = "error";
              }
              break;
          }
        }
        v.details.forEach((element) => {
          let check = false;
          check = v.filterItems(element.code);
          //  console.log("check",check)
          if (!check) {
            element.check = true;
          }
        });

        // v.IncomeData = v.details;
        // if (this.form_valid) {
        //   this.getWeekendsAndImg();

        //   console.log(from);

        //   EmployeeService.createEmployee(from)
        //     .then(res => {
        //       this.dialog_loading = false;
        //       this.closeDialog();
        //     })
        //     .catch(err => {
        //       console.log(err);
        //       this.dialog_loading = false;
        //       this.snackbar = true;
        //       this.errmsg = err;
        //     });
        // }
      };
      reader.onerror = function (e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },

    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then((res) => {
          this.department_items = res.data;
          console.log(this.department_items);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getEmployeeList() {
    //   var position = "";
    //   var search = "";
    //   var page = "";
    //   EmployeeService.getEmployee(
    //     this.branch,
    //     this.department,
    //     position,
    //     search,
    //     page
    //   )
    //     .then(res => {
    //       this.Employee_items = res.data.content;
    //       this.Employee_List = [];
    //       this.Employee_items.forEach(emp => {
    //         if (emp.is_active) {
    //           this.Employee_List.push({
    //             code: emp.code,
    //             name: emp.code + " - " + emp.first_name + " " + emp.last_name
    //           });
    //         }
    //       });
    //       console.log(this.Employee_List);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },

    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    deleteItem(data, index) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.delete") +
        " " +
        data.code +
        " " +
        data.first_name +
        data.last_name +
        "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.index = index;
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_dialog = data;
      this.index = index;
    },

    onDelete() {
      console.log(this.delete_dialog_data.index);
      //this.IncomeData.splice(this.delete_dialog_data.index, 1);
      this.details.splice(this.delete_dialog_data.index, 1);
      console.log("ondelete: importincome", this.details);
    },
    timedRefresh(timeoutPeriod) {
      setTimeout("location.reload(true);", timeoutPeriod);
    },
    async onSave() {
      let v = this;

      var year = new Date().toISOString().substr(0, 4);
      this.detail = [];
      await SettingService.getTaxdetail(year).then((res) => {
        if (res.data != "") {
          res.data.tax_detail.forEach((element) => {
            if (element.name == "personal") {
                this.detail.push({
                  year_tax: year,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: element.max,
                  company_id: localStorage._company_guid,
                });
              } else {
                this.detail.push({
                  year_tax: year,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: 0,
                  company_id: localStorage._company_guid,
                });
              }
          });
        }
      });
      //  await v.IncomeData.forEach(data => {
      //     if (data.status == false) {
      //       v.checkdata = false;
      //     }
      //   });

      // console.log(v.checkdata);
      // if (v.checkdata != false) {
      //   console.log(this.details);

      // if (this.form_valid) {
      await this.details.forEach((element) => {
        let salary = 0;
        let earningday = "0";
        let earninghour = "0";
        if (this.form_model.emp_type == "0") {
          salary = element.salary;
        }
        if (this.form_model.emp_type == "1") {
          earningday = element.daily_earnings;
        }
        if (this.form_model.emp_type == "2") {
          earninghour = element.hourly_earnings;
        }
        if (element.check) {
          v.name.push({
            company_guid: localStorage._company_guid,
            company_id : localStorage._company_guid,
            user_name: "",
            user_password: "",
            code: element.code + "",
            name_title: element.name_title,
            nick_name: element.nick_name,
            is_auto_ss: element.is_auto_ss,
            is_auto_tax: element.is_auto_tax,
            is_training: "0",
            is_special: element.is_special,
            plan_type: "0",
            first_name: element.first_name,
            weekends: "",
            holiday_profile: element.holiday_profile,
            leave_year: new Date().toISOString().substr(0, 4),
            deduct_ss: element.deduct_ss,
            deduct_tax: element.deduct_tax,
            calworkhour: 8,
            income_craft: element.income_craft,
            income_position: element.income_position,
            income_special: element.income_special,
            promptpay_number:
              element.promptpay_number != undefined
                ? element.promptpay_number
                : "",
            not_cal_time: element.not_cal_time,
            payment_type:
              element.payment_type != undefined ? element.payment_type : "",
            last_name: element.last_name,
            nationality: element.nationality,
            emp_type: this.form_model.emp_type,
            earning_daytype: 0,
            daily_monday: 0,
            daily_tuesday: 0,
            daily_wednesday: 0,
            daily_thursday: 0,
            daily_friday: 0,
            daily_saturday: 0,
            daily_sunday: 0,
            daily_holiday: 0,
            earning_hourtype: 0,
            hour_monday: 0,
            hour_tuesday: 0,
            hour_wednesday: 0,
            hour_thursday: 0,
            hour_friday: 0,
            hour_saturday: 0,
            hour_sunday: 0,
            hour_holiday: 0,
            form_hour_1: 0,
            to_hour_1: 0,
            hourearning_1: 0,
            form_hour_2: 0,
            to_hour_2: 0,
            hourearning_2: 0,
            birth_date: element.birth_date,
            address: element.address,
            gender: element.gender,
            phone_num: element.phone_num,
            email: element.email,
            race: element.race,
            line_id: element.line_id,
            citizen_id: element.citizen_id,
            position: element.position != undefined ? element.position : "",
            approver: localStorage._usercode,
            start_work_date: element.start_work_date,
            packing_date: "",
            status: element.status,
            branch: element.branch,
            faction: "",
            department:
              element.department != undefined ? element.department : "",
            start_salary: salary,
            packing_salary: 0,
            daily_earnings: earningday,
            hourly_earnings: earninghour,
            book_bank: element.book_bank,
            bank_name: element.book_name,
            bank_code: element.book_code,
            shift_profile: "",
            conditions_profile: "",
            emp_images: [],
            tax_year: year,
            creator_code: localStorage._usercode,
            tax_detail: this.detail,
            taxsetting: {
              less_exp_rate: 50,
              less_exp_base: 100000,
              reduce_person: 60000,
              reduce_spouse: 0,
              reduce_child_rate: 0,
              reduce_child_base: 30000,
              reduce_parent_rate: 0,
              reduce_parent_base: 30000,
              reduce_handucap_rate: 0,
              reduce_handucap_base: 30000,
              reduce_insurance_base: 100000,
              reduce_insurance: 0,
              reduce_parent_insurance_base: 15000,
              reduce_parent_insurance: 0,
              reduce_inc_residence_base: 100000,
              reduce_inc_residence: 0,
              reduce_ltf: 0,
              reduce_long_insurance: 0,
              reduce_rmf: 0,
              reduct_name_1: "",
              reduct_name_2: "",
              reduct_name_3: "",
              reduct_name_4: "",
              reduct_name_5: "",
              reduct_name_6: "",
              reduct_name_7: "",
              reduct_name_8: "",
              reduct_name_9: "",
              reduct_name_10: "",
              reduct_value_1: 0,
              reduct_value_2: 0,
              reduct_value_3: 0,
              reduct_value_4: 0,
              reduct_value_5: 0,
              reduct_value_6: 0,
              reduct_value_7: 0,
              reduct_value_8: 0,
              reduct_value_9: 0,
              reduct_value_10: 0,
              company_id : localStorage._company_guid,
            },
          });
        }
      });

      let check = false;
      await this.name.forEach((element) => {
        check = this.filterItems(element.code);
        if (!check) {
          v.json_create.push(element);
        } else {
          v.json_update.push(element);
        }
      });
      console.log("create", v.json_create);
      console.log("update", v.json_update);
      if (v.json_create.length > 0 || v.json_update.length > 0) {
        if (v.json_create.length > 0) {
          EmployeeService.importEmployee(v.json_create)
            .then((res) => {
              this.dialog_loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.dialog_loading = false;
              this.snackbar = true;
              this.errmsg = err;
            });
        }
        if (v.json_update.length > 0) {
          EmployeeService.importEmployeeUpdate(v.json_update)
            .then((res) => {
              this.dialog_loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.dialog_loading = false;
              this.snackbar = true;
              this.errmsg = err;
            });
        }
      }
      if (v.json_create.length == 0 && v.json_update.length == 0) {
        this.save_dialog = false;
        this.snack_model.status = true;
        this.snack_model.msg = this.$t(
          "ไม่สามารถบันทึกข้อมูลได้ กรุณาเลือกข้อมูลพนักงานก่อนบันทึก"
        );
        this.snack_model.type = "error";
      }
      if (v.json_create.length > 0 || v.json_update.length > 0) {
        this.snack_model.status = true;
        this.save_dialog = false;
        this.snack_model.msg = this.$t("message.save");
        this.snack_model.type = "success";
        this.goto("employee/list");
      }
    },
    filterItems(code) {
      let check = false;
      let number = 0;
      this.ListEmployee.forEach((element) => {
        if (code == element.code) {
          number++;
        }
      });
      if (number == 0) {
        return false;
      } else {
        return true;
      }
    },
    onUpdate() {
      let v = this;
      (v.details[v.index].code = v.form_dialog.code),
        (v.details[v.index].first_name = v.form_dialog.first_name),
        (v.details[v.index].last_name = v.form_dialog.last_name),
        (v.details[v.index].nick_name = v.form_dialog.nick_name),
        (v.details[v.index].branch = v.form_dialog.branch),
        (v.details[v.index].department = v.form_dialog.department),
        (v.details[v.index].position = v.form_dialog.position),
        (v.details[v.index].startworkday = v.form_dialog.startworkday),
        (v.details[v.index].salary = v.form_dialog.salary),
        (this.snack_model.status = true);
      this.snack_model.status = true;
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
    },
    back() {
      location.reload();
    },
    // toggle() {
    //   this.$nextTick(() => {
    //     console.log(this.selectAllEmp);
    //     if (this.selectAllEmp) {
    //       this.name = [];
    //       this.isChecked = false;
    //     } else {
    //       this.isChecked = true;
    //       this.name = [];
    //       this.Employee_List.forEach(data => {
    //         this.name.push(data.name);
    //       });
    //     }
    //   });
    // }
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
#img_container {
  width: 100px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 20px;
  display: block;
}
</style>